module.exports = __webpack_public_path__ + "static/digitaltwins-c8884f22082df0864b6740712abb85ec.jpeg";